import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";

export const StickyBanner = () => (
  <div
    data-testid="sticky-activation-banner"
    className="fixed top-0 left-0 right-0 z-50 bg-gray-900 text-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-center gap-3 sm:gap-4">
      <Zap className="w-4 h-4 text-amber-400 hidden sm:block" />
      <p className="text-xs sm:text-sm font-medium truncate">
        To activate your account, click here
      </p>
      <Link
        to="/confirmation"
        data-testid="activate-account-btn"
        className="shrink-0 inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-500 text-white text-xs sm:text-sm font-bold px-4 py-1.5 rounded-full transition-colors duration-200"
      >
        Activate Now
        <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  </div>
);
